import { Route } from '../Routing/types';
import { DietSettingsPage } from '@front-activerse/modules';
import descendantRoutes from './descendantRoutes';
import stepsSchemaEn from './stepsSchema';
import { DIET_TYPES_EN, DIET_TYPES_PT } from '../GoalSettings/consts';

const dummy_t = (translationKey: string) => translationKey;

const activeLang = localStorage.getItem('i18nextLng');

const routes: Route[] = [
  {
    path: '/diet-settings/nutritionSettings/*',
    element: (
      <DietSettingsPage
        descendantRoutes={descendantRoutes}
        stepsSchema={stepsSchemaEn}
        currentMainStep="nutritionSettings"
        dietTypes={activeLang === 'pt-BR' ? DIET_TYPES_PT : DIET_TYPES_EN}
      />
    ),
    private: true,
    title: dummy_t('nutritionSettings.navbarTitle'),
    mobileAppTabIdentifier: '',
    descendantRoutes,
  },
];

export default routes;
